import { endpoint } from './api';

/**
 * 메뉴·기능 사용 기록 (월간 사용 리포트·일간 방문자 수, 2026-10). 개인정보 없이 기기마다 임의 번호만 보낸다.
 * 모아 두었다가 몇 초마다 한 번에 POST /api/track.
 */
const KEY = 'csDevice';
let queue: string[] = [];
let timer: any = null;

export const device = () => {
  try {
    let d = localStorage.getItem(KEY);
    if (!d) {
      d = Array.from({ length: 16 }, () => 'abcdefghijklmnopqrstuvwxyz0123456789'[Math.floor(Math.random() * 36)]).join('');
      localStorage.setItem(KEY, d);
    }
    return d;
  } catch (e) {
    return '';
  }
};

const flush = () => {
  timer = null;
  if (!queue.length) return;
  const events = queue.slice(0, 30);
  queue = queue.slice(30);
  const d = device();
  if (!d) return;
  // 사전 확인(CORS preflight)이 필요 없는 단순 폼 전송: 화면을 닫는 순간에도 확실히 전송되게 (keepalive)
  const body = new URLSearchParams();
  body.append('d', d);
  events.forEach((e) => body.append('e[]', e));
  try {
    const t = localStorage.getItem('token');
    if (t) body.append('t', t);
  } catch (e) {}
  try {
    fetch(`${endpoint}/track`, { method: 'POST', body, keepalive: true }).catch(() => {});
  } catch (e) {}
  if (queue.length) timer = setTimeout(flush, 1000);
};

export const track = (event: string) => {
  queue.push(event);
  if (!timer) timer = setTimeout(flush, 4000);
};

try {
  window.addEventListener('pagehide', flush);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flush();
  });
} catch (e) {}

const PAGES: [RegExp, string][] = [
  [/^\/$/, 'page:home'], [/^\/full-sheet-music/, 'page:all'], [/^\/search/, 'page:search'], [/^\/notes\//, 'page:score'],
  [/^\/playlist/, 'page:playlist'], [/^\/chart/, 'page:chart'], [/^\/recent/, 'page:recent'], [/^\/tuner/, 'page:tuner'],
  [/^\/request/, 'page:request'], [/^\/faq/, 'page:faq'], [/^\/hotclip/, 'page:hotclip'], [/^\/pricing/, 'page:pricing'], [/^\/support/, 'page:support'], [/^\/notice/, 'page:notice'], [/^\/membership/, 'page:membership'],
  [/^\/auth\/profile/, 'page:profile'], [/^\/setting/, 'page:setting'], [/^\/(auth\/)?login/, 'page:login'],
];

export const trackPage = (pathname: string) => {
  const hit = PAGES.find(([re]) => re.test(pathname));
  if (hit) track(hit[1]);
};
